import { ComponentProps } from 'react';
import styled from 'styled-components';

import { LoadingOutlined } from '@ant-design/icons';

type LoadingSpinnerProps = ComponentProps<typeof LoadingOutlined> & {
  position?: 'center' | 'left' | 'right';
};
export const LoadingSpinner = ({
  className,
  position = 'center',
  ...loadingOutlinedProps
}: LoadingSpinnerProps) => {
  return (
    <StyledLoadingSpinner className={className} position={position}>
      <LoadingOutlined {...loadingOutlinedProps} />
    </StyledLoadingSpinner>
  );
};

type StyledLoadingSpinnerProps = {
  position: 'center' | 'left' | 'right';
};
const StyledLoadingSpinner = styled.div<StyledLoadingSpinnerProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ position }) =>
    position === 'center'
      ? 'center'
      : position === 'left'
      ? 'flex-start'
      : 'flex-end'};
`;
